import { IProductConfiguration } from "../../../base/common/product.js";
import { BUILD_HASH, BUILD_ENVIRONMENT, BUILD_SEMVER } from "../../../base/common/$__metadata.js";


let product: IProductConfiguration = {
    nameLong: "Needle Editor",
    nameShort: "Needle",

    version: BUILD_SEMVER || "0.0.0-dev",
    commit: BUILD_HASH,
    environment: BUILD_ENVIRONMENT,
    
    youTubeUrl: "https://www.youtube.com/@needle-tools",
}


export {
    product
}